import React, { Component } from "react";
import "antd/dist/antd.css";
import {
  Table,
  Input,
  Button,
  Space,
  PageHeader,
  Breadcrumb,
  Tag,
  DatePicker,
  Select,
  Row,
  Col,
  Tooltip,
} from "antd";
import Highlighter from "react-highlight-words";
import { EyeOutlined, SearchOutlined } from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";
import { getAppUsers } from "../../actions/appUser";
import { Link } from "react-router-dom";
import history from "../../history";
import { connect } from "react-redux";
import { Pagination } from "antd";

const { RangePicker } = DatePicker;
const { Option } = Select;
class AppUserList extends Component {
  state = {
      searchText: '',
      searchedColumn: '',
      data: [],
      serviceDetails: null,
      detail: false,
      visible: false, 
      passVisible: false, 
      modalVisible: false, 
      editModalVisible: false, 
      placement: 'bottom',
      id: '',
      ds: null,
      de: null,
      mobile_number: null,
      authenticated: '',
      p: null,
      current: 1,
    };
    componentDidMount = async () => {
      const res = await this.props.getAppUsers(this.state.p,this.state.ds,this.state.de,this.state.mobile_number,this.state.authenticated);
      this.setState({data: res})
    };
    // handleauthenticated = async (user,active) => {
    //     const code = await this.props.updateAuth(user,active);
    //     if(code === 201 ){
    //       const res = await this.props.getUsers();
    //       this.setState({data: res})
    //     }
    //   }
    getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => {
              this.searchInput = node;
            }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
              Reset
            </Button>
            <Button
              type="link"
              size="small"
              onClick={() => {
                confirm({ closeDropdown: false });
                this.setState({
                  searchText: selectedKeys[0],
                  searchedColumn: dataIndex,
                });
              }}
            >
              Filter
            </Button>
          </Space>
        </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
      onFilter: (value, record) =>
        record[dataIndex]
          ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
          : '',
      onFilterDropdownVisibleChange: visible => {
        if (visible) {
          setTimeout(() => this.searchInput.select(), 100);
        }
      },
      render: text =>
        this.state.searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
          />
        ) : (
          text
        ),
    });
  
    handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      this.setState({
        searchText: selectedKeys[0],
        searchedColumn: dataIndex,
      });
    };
  
    handleReset = clearFilters => {
      clearFilters();
      this.setState({ searchText: '' });
    };
    createData = (sl,user_id,name,email,mobile_number,country,authenticated,created_at,action) => {
      return {sl,user_id,name,email, mobile_number,country,authenticated,created_at,action};
    };
    
    showDrawer = (id) => {
      this.setState({
        visible: true,
        id: id
      });
    };
    handleRefresh = async () => {
      const res = await this.props.getAppUsers();
      this.setState({data: res})
    }
    
    handlePassVisible = (id) => {
      this.setState({passVisible: true,
        id: id
      })
    }
    handleModalVisible = () => {
      this.setState({modalVisible: !this.state.modalVisible})
    }
    handleVisible = async (id) => {
        history.push(`/appUser-details?id=${id}`)
    }
    handleEditModalVisible = (user_id) => {
      this.setState({editModalVisible: !this.state.editModalVisible, id : user_id})
    }
    onClosePass = () => {
      this.setState({
        passVisible: false,
      });
    };
    onClose = () => {
      this.setState({
        visible: false,
      });
    };
    makeLocalTime = (date) => {
      let mainDate = date.split('T')[0];
      let hours = date.split('T')[1].split(':')[0];
      let minutes = date.split('T')[1].split(':')[1];
      var am = true;
      if (hours > 12) {
          am = false;
          hours -= 12
      } else if (hours == 12) {
          am = false;
      } else if (hours == 0) {
          hours = 12
      }
      return mainDate + " , " + hours+":"+minutes + " " + (am ? "a.m" : "p.m")
    }
    handleDate = (date) => {
      if(date){ 
        const ds = new Date(date[0]._d)
        const de = new Date(date[1]._d)
        this.setState({ds: ds.toISOString(),de:de.toISOString()})
      }
      else {
        this.setState({ds: null,de:null})
        return
      }
    }
    handlePageChange = async (page) => {
      const res = await this.props.getAppUsers(page,this.state.ds,this.state.de,this.state.mobile_number,this.state.authenticated);
      this.setState({current: page,data: res})
    }
    handleApiSearch = async () => {
      const res = await this.props.getAppUsers(this.state.p,this.state.ds,this.state.de,this.state.mobile_number,this.state.authenticated);
      this.setState({data: res})
    }
    
    render() {
      const columns = [
        {
          title: 'SL',
          dataIndex: 'sl',
          key: 'sl',
          width: '10%',
        },
        {
          title: 'User ID',
          dataIndex: 'user_id',
          key: 'user_id',
          width: '15%',
          ...this.getColumnSearchProps('user_id'),
        },
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
          width: '15%',
          ...this.getColumnSearchProps('name'),
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          width: '25%',
        },
        {
          title: 'Mobile Number',
          dataIndex: 'mobile_number',
          key: 'mobile_number',
          width: '15%',
          ...this.getColumnSearchProps('mobile_number'),
        },
        
        {
          title: 'Country',
          dataIndex: 'country',
          key: 'country',
          width: '15%',
          ...this.getColumnSearchProps('country'),
        },
        
        {
          title: 'Status',
          dataIndex: 'authenticated',
          key: 'authenticated',
          width: '20%',
          ...this.getColumnSearchProps('authenticated'),
        },
        
        {
          title: 'Created Date',
          dataIndex: 'created_at',
          key: 'created_at',
          width: '20%',
          ...this.getColumnSearchProps('created_at'),
        },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          width: '25%',
        },
      ];
      const {data} = this.state
      const rows = [
        data?.users
          ? data?.users.map((item,id) => this.createData(
              id + 1,
              item.user_id, 
              item.name,
              item.email,
              item.mobile_number,
              item.country,
              item.authenticated ? <Tag color="#bde235">Authenticate</Tag> : <Tag color="#cf6020">Unauthenticate</Tag>,
              this.makeLocalTime(item.created_at), 
              <>
              <Button size="small" type="primary" icon={<EyeOutlined  />} onClick={() => this.handleVisible(item.user_id)}>View</Button> &nbsp;
              {/* <Button size="small" type="primary" icon={<EditOutlined  />} onClick={() => this.handleEditModalVisible(item.order_id)}>Edit</Button> &nbsp; */}
              {/* <Popconfirm title="Are you sure？" okText="Yes" cancelText="No" onConfirm={() => this.showDrawer(item.order_id)}><Button size="small" type="danger" icon={<DeleteOutlined  />}>Delete</Button></Popconfirm> */}
            
            </>
            ))
          : "",
      ];
      return (
        <Content >


          <Breadcrumb style={{padding:"10px 0px"}}>
            <Breadcrumb.Item><Link to="/dashboard">Home</Link></Breadcrumb.Item>
            <Breadcrumb.Item>User List</Breadcrumb.Item>
          </Breadcrumb>
          <PageHeader
            ghost={false}
            onBack={() => window.history.back()}
            title="User List"
            subTitle="App Management"
            extra={
              <Tag color="#2db7f5"> {data?.count} data found</Tag>
            }
          >
          </PageHeader>
          <Row gutter={16}>
              <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                  <Input placeholder="Mobile number" allowClear style={{width:'99%'}} onChange={(e)=>this.setState({mobile_number:e.target.value})} />
              </Col>
              <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                  <Select
                      showSearch
                      style={{ width: "99%" }}
                      placeholder="Select a status"
                      name="status"
                      optionFilterProp="children"
                      onChange={(e)=>this.setState({authenticated:e})}
                      filterOption={(input, option) =>
                      option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                      }
                  >
                      <Option value="">None</Option>
                      <Option value="active">Authenticate</Option>
                      <Option value="deactive">Unauthenticate</Option>
                  </Select>
               </Col>
             <br />
             <br />
              
              <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                  <RangePicker onChange={this.handleDate} format="YYYY/MM/DD" style={{width: '80%'}} />
                  &nbsp;
                  &nbsp;
                  <Tooltip title="search" onClick={this.handleApiSearch}>
                      <Button type="primary" shape="circle" icon={<SearchOutlined />} />
                  </Tooltip>
              </Col>
          </Row>
          <Table columns={columns} dataSource={rows[0]} scroll={{ x: 1000 }} sticky  pagination={false} />
          <Pagination  defaultCurrent={1} total={data?.count} style={{textAlign: 'right', paddingRight: '100px'}} onChange={(page) => this.handlePageChange(page)} />
{/* 
          <Pagination current={this.state.current} total={data?.count}  onChange={this.handlePageChange} /> */}
          {/* <Remarks placement={placement} visible={visible} fnc={this.onClose} id={id} delFnc = {this.props.deleteUser} data = {this.state.data} refresh = {this.handleRefresh} />
          <ChangePass placement={placement} visible={passVisible} fnc={this.onClosePass} id={id} passFnc = {this.props.getAppUsers} data = {this.state.data} refresh = {this.handleRefresh} />
          
          {this.state.editModalVisible ? <EditModalForm visible={this.state.editModalVisible} setVisible={this.handleEditModalVisible} user_id={this.state.id} refresh = {this.handleRefresh} /> : null}
          <ModalForm visible={this.state.modalVisible} setVisible={this.handleModalVisible} refresh = {this.handleRefresh}/> */}
      </Content>
      );
    }
  }

export default connect(null, {
  getAppUsers
})(AppUserList);
